import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="track"
//
// Fires a Plausible custom event. Two usages:
//   - Auto-fire on connect for server-driven events flashed after a redirect
//     (e.g. "Cable: Created", "License: Purchased") via layouts/_tracking.
//   - Fire on a triggered action (data-action="click->track#fire") for outbound
//     CTAs that open in a new tab (e.g. "License: Checkout Started"), so the
//     event is sent before navigation.
export default class extends Controller {
  static values = {
    name: String,
    props: { type: Object, default: {} },
    onConnect: { type: Boolean, default: true },
  };

  connect() {
    if (this.onConnectValue) this.fire();
  }

  fire() {
    if (typeof window.plausible !== "function") return;

    window.plausible(this.nameValue, {
      props: { hostname: window.location.hostname, ...this.propsValue },
    });
  }
}
